import { render } from "./vid-dog-pril.vue?vue&type=template&id=17e2b23a"
import script from "./vid-dog-pril.vue?vue&type=script&setup=true&lang=js"
export * from "./vid-dog-pril.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/nsi/vid-dog-pril/vid-dog-pril.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "17e2b23a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('17e2b23a', __exports__)) {
    api.reload('17e2b23a', __exports__)
  }
  
  module.hot.accept("./vid-dog-pril.vue?vue&type=template&id=17e2b23a", () => {
    api.rerender('17e2b23a', render)
  })

}


export default __exports__